import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Box, Log, ScanTypes} from "../../model/weak-entities";
import {Doctor} from "../../model/doctor";
import * as moment from 'moment';
import {Platform} from "ionic-angular";
import {File} from "@awesome-cordova-plugins/file/ngx";
import {FileOpener} from "@awesome-cordova-plugins/file-opener/ngx";
import {Practice} from "../../model/practice";
import {AppStateProvider} from "../app-state/app-state";

@Injectable()
export class HelpProvider {

  constructor(private platform: Platform,
              private file: File,
              private fileOpener: FileOpener,
              private appState: AppStateProvider) {}

  public async submitLogs(logs: Log[], doctor: Doctor, practice: Practice, box: Box) {
    let now = moment().format('YYYY MM DD HH-mm-ss');
    let fileName = `${now}_${doctor.Email}_Logs.txt`;

    // Write header
    let header = `
-----------------------------------------------------------
SYNAPSE BRIDGE LOG SUBMISSION
-----------------------------------------------------------

Log Retrieval Date: ${now}

-- Doctor Info --

Doctor Id: ${doctor.Id}
Doctor Email: ${doctor.Email}
Doctor Name: ${doctor.FirstName} ${doctor.LastName}

-- Practice Info --

Practice Id: ${practice.Id}
Practice Name: ${practice.Name}

-- Bridge Info --

Bridge Id: ${box.DeviceId}
Bridge Location Id: ${box.LocationId}
Bridge SSID: ${box.Ssid}
Bridge IP Address: ${box.IpAddress}

-- Log Info --

Number of Log Files: ${logs.length}

-----------------------------------------------------------

-----------------------------------------------------------
LOG FILES
-----------------------------------------------------------


      `;

    if (this.appState.isIpad) {
      // Create file
      await this.file.createFile(this.file.dataDirectory, fileName, true);

      await this.file.writeFile(this.file.dataDirectory, fileName, header, { append: true });

      for (let log of logs) {
        let logHeader = `
-----------------------------------------------------------
Log Name: ${log.fileName}
-----------------------------------------------------------


        `;

        await this.file.writeFile(this.file.dataDirectory, fileName, logHeader, { append: true });

        await this.file.writeFile(this.file.dataDirectory, fileName, log.contents, { append: true });
      }

      this.fileOpener.open(this.file.dataDirectory + fileName, 'application/text');
    } else {
      let logging = header;

      for (let log of logs) {
        let logHeader = `
-----------------------------------------------------------
Log Name: ${log.fileName}
-----------------------------------------------------------


        `;

        logging += logHeader;

        logging += log.contents;
      }

      let data = new Blob([logging], {type: 'text/plain'});

      let textFile = window.URL.createObjectURL(data);

      window.open(textFile, '_blank');
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/help/help.ts